/**
 * Hook that returns the Portfolio link with default view filters if one exists
 * This ensures clicking the Portfolio nav link always loads the default view
 */

import { useMemo } from 'react';

import { useGetFilterViews } from '@/api/REST/filterViews';

const PORTFOLIO_PAGE_IDENTIFIER = 'ProjectPortfolioOverview';

export function usePortfolioDefaultLink() {
  const { data: filterViews = [] } = useGetFilterViews(
    PORTFOLIO_PAGE_IDENTIFIER,
  );

  return useMemo(() => {
    const defaultView = filterViews.find((v) => v.isDefault);

    if (defaultView?.filterParameters) {
      // Construct URL with filters using URLSearchParams for proper encoding
      const params = new URLSearchParams();
      params.set('filters', defaultView.filterParameters);
      return `/projects?${params.toString()}`;
    }

    // No default view or default view has no filters
    return '/projects';
  }, [filterViews]);
}
